import type { LoginType } from '@/domains/shared';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { CHANNEL_SOURCE, EMPOWER_TYPE, SDK_ENV, loginSDK, type Channels } from '@eureka/shared/login-sdk';
import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';
import { I18nOrigin } from '@/services/i18n-service';

export interface LoginDialogService {
    open(withoutClose?: boolean, channels?: Channels, loginType?: LoginType): Promise<void>
}

@injectable()
export class LoginDialogServiceImpl implements LoginDialogService {
    private _channels: Channels = {
        from_page: EMPOWER_TYPE.AIR_HOME,
        channel_source: CHANNEL_SOURCE.AIR_EUREKA,
    }

    private _sdkEnv?: SDK_ENV;

    constructor(
        @inject(I18nOrigin)
        private readonly _i18n: I18nOrigin
    ) {
        this._sdkEnv = [DeployEnv.US, DeployEnv.EU].includes(REGION) ? SDK_ENV.US : SDK_ENV.CN;
        loginSDK.setEnv(this._sdkEnv).setI18n(this._i18n).setChannels(this._channels)
        loginSDK.handleThirdPartyLoginErrors()
    }

    open(
        withoutClose = false,
        channels?: Channels,
        loginType?: LoginType
    ) {
        if (channels) {
            this._channels = channels
            loginSDK.setChannels(this._channels)
        }
        return loginSDK.open({
            withoutClose,
            loginType,
        }).then(async() => {
            window.location.reload();
        })
    }
}

export const LoginDialogService = Symbol('LoginDialogService');
